import { javascript } from '@codemirror/lang-javascript';

// eslint-disable-next-line unicorn/prevent-abbreviations
export default class DevMfController {
	/* @ngInject */
	constructor() {
		// this.data = [
		// 	{
		// 		kid: 'K_NODE;PERS_OLIVIER',
		// 		name: 'Olivier BERAUD',
		// 	},
		// ];

		this.data = 'K_NODE;KP_OLIVIER';

		this.myForm = {};
		this.readOnly = false;
		this.settings = {
			order:       'K_NODE;PERSON',
			suggest:     'K_NODE;PERSON',
			placeholder: 'My placeholder',
			mode:        'label',
			options:     {
				displayAddBtn:       true,
				displayExpandButton: false,
				displaySuggestBtn:   true,
				displayValues:       true,
				lastForm:            false,
				name:                'Olivier 2',
				uniqueKid:           true,
			},
		};
		this.validate = {
			card:   '1-1',
			custom: undefined,
		};
	}

	onEditorSetup() {
		return [
			javascript(),
		];
	}

	// eslint-disable-next-line class-methods-use-this
	/**
	 * @param {any} query
	 * @param {any} event
	 */
	create(query, event) {
		// eslint-disable-next-line no-console
		console.log('create', query, event);
	}
}
